module.exports = __webpack_public_path__ + "media/giggle3.5df15a5b.mp3";